import { useSyncExternalStore } from 'react';
import { getPreferences, putPreferences } from '@/api/preferences';
import { PreferencesStore } from './preferencesStore';

/** The one preferences store of the app (see preferencesStore.ts). */
export const preferencesStore = new PreferencesStore({
  get: getPreferences,
  put: putPreferences,
  storage: window.localStorage,
});

export const usePreferencesState = () =>
  useSyncExternalStore(preferencesStore.subscribe, preferencesStore.getState);

/** The current preferences and the way to change them. */
export const usePreferences = () => {
  const state = usePreferencesState();
  return {
    prefs: state.prefs,
    state,
    update: preferencesStore.update.bind(preferencesStore),
    retry: preferencesStore.retry.bind(preferencesStore),
  };
};

export { DEFAULT_PREFERENCES } from './preferencesStore';
